export default [
    { lat: 48.190397, lng: 16.454898 },
    { lat: 48.183072, lng: 16.440478 },
    { lat: 48.161550, lng: 16.380053 },
    { lat: 48.175289, lng: 16.338168 },
    { lat: 48.207789, lng: 16.294223 },
    { lat: 48.254443, lng: 16.373187 },
]
